import Vue from "vue";
import VueRouter from "vue-router";
// import Select from '../views/Select.vue'

Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
// 注意，增加route需要同步在 copy.js 中 filepaths 增加相应路径，否则会导致无法访问
const routes = [
  // {
  //   path: '/',
  //   name: 'Select',
  //   component: Select
  // },
  {
    path: "/",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Login.vue"),
  },
  {
    path: "/Home",
    name: "Home",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Home.vue"),
  },
  {
    path: "/Faq",
    name: "Faq",
    component: () => import(/* webpackChunkName: "about" */ "../views/Faq.vue"),
  },
  {
    path: "/Language",
    name: "Language",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Language.vue"),
  },
  {
    path: "/BeforeDel",
    name: "BeforeDel",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/BeforeDel.vue"),
  },
  {
    path: "/DelOperation",
    name: "DelOperation",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/DelOperation.vue"),
  },
  {
    path: "/DeletePend",
    name: "DeletePend",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/DeletePend.vue"),
  },
  {
    path: "/RequestDataPend",
    name: "RequestDataPend",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/RequestDataPend.vue"),
  },
  {
    path: "/CancelPend",
    name: "CancelPend",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/CancelPend.vue"),
  },
  {
    path: "/forbiddenRequest",
    name: "forbiddenRequest",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/forbiddenRequest.vue"),
  },
  {
    path: "/DoNotSell",
    name: "DoNotSell",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/DoNotSell.vue"),
  },
  {

    path: '/RequestDataCopy',
    name: 'RequestDataCopy',
    component: () => import( /* webpackChunkName: "about" */ '../views/RequestDataCopy.vue')
  },
  {
    path: "/fb_query_webhook",
    name: "DeleteFacebookInfo",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/DeleteFacebookInfo.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});
// 登录验证
router.beforeEach((to, from, next) => {
  let token = window.$cookie.get("token");
  if (!token) {
    if (
      to.path === "/Login" ||
      (from.path === "/" && to.path === "/Login") ||
      to.path === "/" ||
      to.path === "/fb_query_webhook"
    ) {
      next();
    } else {
      if (to.name) {
        next("/?f=" + to.name);
      } else {
        next("/");
      }
    }
  } else {
    next();
  }
});

export default router;
